export const calculateTime = (timestamp: number) => {
  const oneMinute = 1000 * 60;
  const oneHour = oneMinute * 60;
  const oneDay = oneHour * 24;
  const days = Math.floor(timestamp / oneDay);
  const hours = Math.floor((timestamp - days * oneDay) / oneHour);
  const minutes = Math.floor((timestamp - days * oneDay - hours * oneHour) / oneMinute);
  const seconds = Math.floor((timestamp - days * oneDay - hours * oneHour - minutes * oneMinute) / 1000);
  return {
    days,
    hours,
    minutes,
    seconds,
  };
};

const autoAddZero = (num: number) => (num >= 10 ? String(num) : `0${num}`);

export const formatToText = (days: number, hours: number, minutes: number, seconds: number, format: string) => {
  const isShowDay = /DD/.test(format); // 是否展示天
  const newHours = isShowDay ? hours : hours + days * 24;
  return format.replace(/DD/, autoAddZero(days)).replace(/HH/, autoAddZero(newHours)).replace(/mm/, autoAddZero(minutes)).replace(/ss/, autoAddZero(seconds));
};
